import { render } from "./UnReachedUsersSetting.vue?vue&type=template&id=cbbefde0"
import script from "./UnReachedUsersSetting.vue?vue&type=script&lang=ts"
export * from "./UnReachedUsersSetting.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem});
